<template>
	<div class="vld-parent">
    <LoadingV2 :fullPage="fullPage" :loading="loading" :mensajeLoading="mensajeLoading"></LoadingV2>
    <a-layout :style="{ height: windowHeight }">
			<a-layout-content>
				<RouterView @handleLoading="handleLoading" @footer="footer" :getWindowHeight="getWindowHeight" :footerHeight="footerHeight"/>
			</a-layout-content>
      <a-layout-footer v-if="footer" ref="footerRef">
          <DashboardFooter />
      </a-layout-footer>
		</a-layout>
  </div>
</template>
<script>
import LoadingV2 from '@/components/Widgets/LoadingV2';
import DashboardFooter from '../components/Footers/DashboardFooter.vue';
import { RouterView } from 'vue-router';
import { selectProps } from 'ant-design-vue/es/vc-select';
export default {
  components: {
    LoadingV2,
    DashboardFooter
  },
  data() {
    return {
      loading: false,
      windowHeight: '',
      footerHeight: '',
      mensajeLoading: 'Cargando',
      fullPage: true,
      footer: false
    };
  },
  created() {
    this.assignHeight();
  },
  mounted() {
    this.$nextTick(this.assignHeight);
    window.addEventListener('resize', this.assignHeight);
  },
  methods: {
    async handleLoading(loading, title = '') {
      // console.log(title);
      selectProps()
      if (loading == false) {
        this.mensajeLoading = "Cargando"
      } else {
        this.mensajeLoading = (title != '') ? title : this.mensajeLoading
      }
      this.loading = loading;
    },
    assignHeight() {
        this.getWindowHeight();
        if (this.$refs.footerRef) {
          if (this.$refs.footerRef.$el) {
            const footerElement = this.$refs.footerRef.$el;
            this.footerHeight = footerElement.offsetHeight + 'px';
            // console.log(this.footerHeight)
          } 
        }
    },
    getWindowHeight(returnValue = false) {
        const valuewindowHeight = window.innerHeight;
        if (returnValue) {
            return valuewindowHeight + 'px';
        } else {
            this.windowHeight = valuewindowHeight + 'px';
        }
      
    },
  }
}
</script>